import { apiClient } from '../../lib/api-client';
import type { BillingListFilters, BillingModule, BillingRow, Pagination } from './types';

interface ApiResponse<T> { success: true; data: T }
interface PaginatedResponse<T> extends ApiResponse<T[]> { pagination: Pagination }

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchBillingList = async (filters: BillingListFilters) => {
  const response = await apiClient.get<PaginatedResponse<BillingRow>>('/billing/list', { params: compactParams(filters) });
  return response.data;
};

export const approveBillingRow = async (module: BillingModule, id: string) => {
  const response = await apiClient.patch<ApiResponse<{ id: string; module: BillingModule; approved: boolean }>>(`/billing/${module}/${id}/approve`);
  return response.data.data;
};
